module.exports = __webpack_public_path__ + "images/marketing/landing-icons.svg";